"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderSimilarProperties = exports.renderSimilarItems = exports.renderConfigGroup = exports.renderAddressGroup = exports.renderTitleGroup = exports.renderPropertyFloor = exports.renderPropSold = exports.renderListingType = exports.renderPpsf = exports.renderSizeSaGfa = exports.renderBaths = exports.renderBeds = exports.renderSize = exports.DetailMapDispatchToProps = exports.DetailMapStateToProps = exports.detail = exports.mapDispatchToProps = void 0;
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var ShareAction_1 = require("@/pages/common/actions/ShareAction");
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var CallOrEmail_1 = require("@/pages/common/components/CallOrEmail");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var Enquire_1 = require("@/pages/common/components/Enquire");
var Login_1 = require("@/pages/common/components/Login");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var Share_1 = require("@/pages/common/components/Share");
var Signup_1 = require("@/pages/common/components/Signup");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var DetailAction_1 = require("@/pages/detail/actions/DetailAction");
var NearbyAction_1 = require("@/pages/detail/actions/NearbyAction");
var DetailGalleryMain_1 = require("@/pages/detail/components/DetailGalleryMain");
var DetailPopup_1 = require("@/pages/detail/components/DetailPopup");
var MapObject_1 = require("@/pages/detail/components/MapObject");
var Mortgage_1 = require("@/pages/detail/components/Mortgage");
var NearbyCommuteEstimator_1 = require("@/pages/detail/components/NearbyCommuteEstimator");
var DetailGalleryState_1 = require("@/pages/detail/states/DetailGalleryState");
var DetailPopNearbyTabType_1 = require("@/pages/detail/states/DetailPopNearbyTabType");
var DetailPopTabType_1 = require("@/pages/detail/states/DetailPopTabType");
var PlaceResultListItems_1 = require("@/pages/place/components/PlaceResultListItems");
var Breadcrumb_1 = require("@/pages/search/components/Breadcrumb");
var ExistingLogin_1 = require("@/pages/search/components/ExistingLogin");
var ResultPageState_1 = require("@/pages/search/states/ResultPageState");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var format_1 = require("@/utils/format");
var PlaceFeatures_1 = require("@/utils/PlaceFeatures");
var classnames_1 = require("classnames");
var myokay_map2_1 = require("@okay/myokay-map2");
var React = require("react");
var react_redux_1 = require("react-redux");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var VideoAction_1 = require("@/pages/detail/actions/VideoAction");
var Message_1 = require("@/pages/common/components/Message");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var DetailChart_1 = require("@/pages/detail/components/DetailChart");
var DetailTransactions_1 = require("@/pages/detail/components/DetailTransactions");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var mapStateToProps = function (state) {
    return __assign(__assign({}, state.detail), { currencyCode: state.layout.currencies.options.filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].code2, langCode: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1, isLoggedIn: state.user.id ? true : false, hasVr: state.detail.gallery.items.find(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.VR; })
            ? true
            : false, hasVideo: state.detail.gallery.items.find(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.VIDEO; })
            ? true
            : false, hasFloorPlan: state.detail.galleryFloorPlans.items &&
            state.detail.galleryFloorPlans.items.length > 0, layout: state.layout, symbol: state.layout.currencies.options.filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol, googleApi: state.layout.googleApi, callOrEmailActive: state.layout.callOrEmailActive, gtmId: state.server ? state.server.googleTagManagerAmpId : '', dfoot: state.dfoot, isMobile: state.mobile, defaultAltText: state.detail.property.building });
};
exports.DetailMapStateToProps = mapStateToProps;
exports.mapDispatchToProps = function (dispatch) { return ({
    closePopup: function () { return dispatch(DetailAction_1.default.closePopup()); },
    onGridImageClick: function (id, i, photo) { return dispatch(DetailAction_1.default.onGridImageClick(id, i, photo)); },
    onMenuItemClick: function (type) { return dispatch(DetailAction_1.default.onMenuItemClick(type)); },
    onVrClick: function () { return dispatch(DetailAction_1.default.onVrClick()); },
    onNearbyClick: function () { return dispatch(DetailAction_1.default.onNearbyClick()); },
    onPropertyClick: function () { return dispatch(DetailAction_1.default.onPropertyClick()); },
    onMyPlacesClick: function () { return dispatch(DetailAction_1.default.onMyPlaceClick()); },
    onFilterClick: function (filterType) { return dispatch(NearbyAction_1.default.onFilterClick(filterType)); },
    onMoreClick: function () { return dispatch(NearbyAction_1.default.onMoreClick()); },
    onMapObjectClick: function (object, i) { return dispatch(NearbyAction_1.default.onMapObjectClick(object, i)); },
    onMapObjectsClick: function (objects) { return dispatch(NearbyAction_1.default.onMapObjectsClick(objects)); },
    onAddPlaceClick: function () { return dispatch(NearbyAction_1.default.onAddPlaceClick()); },
    onResultItemClick: function (item, i) { return dispatch(NearbyAction_1.default.onResultItemClick(item, i)); },
    onMyPlaceClick: function (item, i) { return dispatch(NearbyAction_1.default.onMyPlaceClick(item, i)); },
    onMarkerClick: function (object, i) { return dispatch(NearbyAction_1.default.onMarkerClick(object, i)); },
    onMortgageTabClick: function (tab) { return dispatch(DetailAction_1.default.onMortgageTabClick(tab)); },
    onEnquireClick: function () { return dispatch(DetailAction_1.default.onEnquireClick()); },
    onWhatsAppClick: function () { return dispatch(LayoutAction_1.default.onPureWhatsAppClicked()); },
    onCallClick: function () { return dispatch(LayoutAction_1.default.onCallClicked()); },
    onBackClick: function () { return dispatch(DetailAction_1.default.onBackClick()); },
    onCustomizeClick: function () { return dispatch(DetailAction_1.default.onCustomizeClick()); },
    onFeatureExpandClick: function () { return dispatch(DetailAction_1.default.setFeatureExpand(true)); },
    onFavClick: function (property) { return dispatch(DetailAction_1.default.onFavClick(property)); },
    onShareClick: function () { return dispatch(ShareAction_1.default.onShareClicked()); },
    onMenuClick: function () { return dispatch(DetailAction_1.default.onMenuClick()); },
    onEnquireSubmit: function (enquiry, e) { return dispatch(EnquireAction_1.default.onEnqurieSubmit(enquiry, e.currentTarget.id)); },
    onBuildingFollowClick: function () { return dispatch(DetailAction_1.default.onBuildingFollowClick()); },
    onBuildingUnfollowClick: function () { return dispatch(DetailAction_1.default.onBuildingUnfollowClick()); },
    onDistrictFollowClick: function () { return dispatch(DetailAction_1.default.onDistrictFollowClick()); },
    onDistrictUnfollowClick: function () { return dispatch(DetailAction_1.default.onDistrictUnfollowClick()); },
    onNearbyItemClick: function (it, i) { return dispatch(NearbyAction_1.default.onNearbyItemClick(it, i)); },
    onNearbyItemShow: function (it, i) { return dispatch(NearbyAction_1.default.onNearbyItemShow(it, i)); },
    onDonutHover: function (item, index) { return dispatch(DetailAction_1.default.onDonutHover(item, index)); },
    onSimilarFavClick: function (item) { return dispatch(PlaceAction_1.default.favClicked(item)); },
    onSimilarEnquireClicked: function (item) { return dispatch(ResultAction_1.default.onEnquireClicked(item)); },
    onCurrentTimeChanged: function (currentTime) { return dispatch(VideoAction_1.default.onCurrentTimeChanged(currentTime)); },
    onTotalTimeChanged: function (totalTime) { return dispatch(VideoAction_1.default.onTotalTimeChanged(totalTime)); },
    onEnded: function () { return dispatch(VideoAction_1.default.onEnded()); },
    onChangeStart: function () { return dispatch(VideoAction_1.default.onChangeStart()); },
    onChange: function (newCurrent) { return dispatch(VideoAction_1.default.onChange(newCurrent)); },
    onChangeEnd: function (newCurrent) { return dispatch(VideoAction_1.default.onChangeEnd(newCurrent)); },
    onPlayToggle: function () { return dispatch(VideoAction_1.default.onPlayToggle()); },
    onMutedToggle: function () { return dispatch(VideoAction_1.default.onMutedToggle()); },
    onPlaylistClick: function (video) { return dispatch(VideoAction_1.default.onPlaylistClick(video)); },
    onPlayerClick: function () { return dispatch(VideoAction_1.default.onPlayerClick()); },
    onItemClicked: function (item) { return dispatch(ResultAction_1.default.onItemClicked(item)); },
}); };
exports.DetailMapDispatchToProps = exports.mapDispatchToProps;
var renderSimilarProperties = function (props) {
    var hasSimilarProperties = props.similar.results && props.similar.results.length > 0;
    var hasSameBuildingProperties = props.sameBuilding.results && props.sameBuilding.results.length > 0;
    // Default to 'similar' if sameBuilding has no properties, otherwise default to 'sameBuilding'
    var _a = React.useState(hasSameBuildingProperties ? 'sameBuilding' : 'similar'), activePropertiesTab = _a[0], setActivePropertiesTab = _a[1];
    // Switch tabs based on availability
    React.useEffect(function () {
        if (!hasSameBuildingProperties && hasSimilarProperties) {
            setActivePropertiesTab('similar');
        }
        else if (hasSameBuildingProperties && !hasSimilarProperties) {
            setActivePropertiesTab('sameBuilding');
        }
        else if (hasSameBuildingProperties) {
            // If both have properties, prefer sameBuilding
            setActivePropertiesTab('sameBuilding');
        }
        else if (hasSimilarProperties) {
            // If only similar has properties
            setActivePropertiesTab('similar');
        }
    }, [hasSimilarProperties, hasSameBuildingProperties]);
    if (!hasSimilarProperties && !hasSameBuildingProperties)
        return null;
    var renderTabButton = function (tabType, label, isAvailable) {
        if (!isAvailable)
            return null;
        var tabClass = classnames_1.default([
            'okay-tabs-btn',
            { 'okay-tabs-btn--active': activePropertiesTab === tabType }
        ]);
        return (React.createElement("a", { key: tabType, onClick: function () { return setActivePropertiesTab(tabType); }, className: tabClass }, label));
    };
    var renderActiveDesktopContent = function () {
        if (activePropertiesTab === 'similar' && hasSimilarProperties) {
            return (React.createElement("div", { className: "c-tableview c-tableview--extra u-mobile-hidden " + (props.similar.currentOrder === PlaceState_1.AvailableSortOrder.ASC ? 'c-tableview--asc' : ''), style: { paddingTop: '20px' } },
                React.createElement("div", { className: "c-tableview__section l-pad l-pad--2" },
                    React.createElement(PlaceResultListItems_1.default, __assign({}, props.similar, { symbol: props.symbol, googleApikey: props.googleApi, lang: props.langCode }))),
                props.similar.results.length ? (React.createElement("div", { className: "l-pad--2 u-text-center" },
                    React.createElement("a", { target: "_blank", href: props.availableViewMoreLink, className: "o-btn o-btn--primary" },
                        React.createElement("span", { className: "fal fa-search" }),
                        " \u00A0 ",
                        props.t.searchProperties))) : null));
        }
        else if (activePropertiesTab === 'sameBuilding' && hasSameBuildingProperties) {
            return (React.createElement("div", { className: "c-tableview c-tableview--extra u-mobile-hidden " + (props.sameBuilding.currentOrder === PlaceState_1.AvailableSortOrder.ASC ? 'c-tableview--asc' : ''), style: { paddingTop: '20px' } },
                React.createElement("div", { className: "c-tableview__section l-pad l-pad--2" },
                    React.createElement(PlaceResultListItems_1.default, __assign({}, props.sameBuilding, { symbol: props.symbol, googleApikey: props.googleApi, lang: props.langCode }))),
                props.sameBuilding.results.length ? (React.createElement("div", { className: "l-pad--2 u-text-center" },
                    React.createElement("a", { target: "_blank", href: props.sameBuildingMoreLink, className: "o-btn o-btn--primary" },
                        React.createElement("span", { className: "fas fa-search" }),
                        " \u00A0 ",
                        props.t.viewMore))) : null));
        }
        return null;
    };
    var renderActiveMobileContent = function () {
        if (activePropertiesTab === 'similar' && hasSimilarProperties) {
            return renderSimilarItems(props);
        }
        else if (activePropertiesTab === 'sameBuilding' && hasSameBuildingProperties) {
            return renderSameBuildingItems(props);
        }
        return null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "l-pad-top l-pad-top--4" },
            React.createElement("div", { className: "l-prop__listing-tabs" },
                React.createElement("h2", null, props.referringType === SfilterTypeGroup_1.SfilterType.RENT ? props.t.similarPropertiesForRent : props.t.similarPropertiesForSale),
                React.createElement("div", { className: "okay-tabs" },
                    renderTabButton('sameBuilding', props.t.sameBuildingProperties, hasSameBuildingProperties),
                    renderTabButton('similar', props.t.sameDistrictProperties, hasSimilarProperties)))),
        renderActiveDesktopContent(),
        renderActiveMobileContent()));
};
exports.renderSimilarProperties = renderSimilarProperties;
var renderFavIcon = function (isSaved) {
    if (!isSaved) {
        return React.createElement("span", { className: "fal fa-heart" });
    }
    return React.createElement("span", { className: "fas fa-heart" });
};
var renderSimilarRow = function (props) { return function (row, i) {
    var propertyLink = propertyToUrl_1.propertyToUrl(props.langCode, row.building, row.referenceId, props.referringType);
    var price = row.price
        ? (row.type === SfilterTypeGroup_1.SfilterType.BUY
            ? format_1.default.currencySale(row.price, props.langCode, props.currencyCode)
            : format_1.default.currencyLease(row.price, props.langCode, props.currencyCode))
        : props.t.subjectToOffer;
    var sizeValue = format_1.default.comma(row.size);
    var saGfa = row.sizeSaleable ? props.t.sa : props.t.gfa;
    var onSimilarFavClick = function () { return props.onSimilarFavClick(row); };
    return (React.createElement("div", { key: i, className: "c-propsmsimilar__item" },
        React.createElement("a", { href: propertyLink, className: "c-propsmsimilar__img" },
            React.createElement("img", { loading: 'lazy', src: row.images.length ? row.images[0].path : '', alt: "" })),
        React.createElement("div", { className: "c-propsmsimilar__info" },
            React.createElement("a", { href: propertyLink, className: "c-propsmsimilar__name" }, row.building),
            React.createElement("div", { className: "c-propsmsimilar__price" }, price),
            React.createElement("div", { className: "c-propsmsimilar__size" },
                React.createElement("div", { className: "c-propsmsimilar__sizegroup" },
                    React.createElement("div", { className: "c-propsmsimilar__sizevalue" }, sizeValue),
                    React.createElement("div", { className: "c-propsmsimilar__sizeunit" },
                        props.t.sqft,
                        " (",
                        saGfa,
                        ")")),
                React.createElement("div", { className: "c-propsmsimilar__sizegroup" },
                    React.createElement("div", { className: "c-propsmsimilar__sizevalue" }, row.amenities.find(function (it) { return it.key === 'bed'; }).value),
                    React.createElement("div", { className: "c-propsmsimilar__sizeunit" }, props.t.bd)),
                React.createElement("div", { className: "c-propsmsimilar__sizegroup" },
                    React.createElement("div", { className: "c-propsmsimilar__sizevalue" }, row.amenities.find(function (it) { return it.key === 'bath'; }).value),
                    React.createElement("div", { className: "c-propsmsimilar__sizeunit" }, props.t.ba)))),
        React.createElement("div", { className: "c-propsmsimilar__fav", onClick: onSimilarFavClick }, renderFavIcon(row.isSaved))));
}; };
var renderSimilarItems = function (props) {
    if (!props.similar.results)
        return null;
    return (React.createElement("div", { className: "c-propsmsimilar" },
        React.createElement("div", { className: "c-propsmsimilar__items" },
            props.similar.results.slice(0, 5).map(renderSimilarRow(props)),
            React.createElement("div", { className: "c-propsmsimilar__item" },
                React.createElement("div", { className: "c-propsmsimilar__follow" },
                    React.createElement("div", { className: "c-propsmsimilar__capture" },
                        props.t.keepUpdateWith,
                        " ",
                        props.property.building),
                    React.createElement("div", { className: "c-propsmsimilar__action" },
                        React.createElement("button", { onClick: props.onBuildingFollowClick, className: "o-btn o-btn--flat" }, props.t.follow))))),
        React.createElement("div", { className: "c-propsmsimilar__more" },
            React.createElement("a", { className: "o-btn o-btn--flat", href: props.availableViewMoreLink }, props.t.viewMore))));
};
exports.renderSimilarItems = renderSimilarItems;
var renderSameBuildingItems = function (props) {
    if (!props.sameBuilding.results)
        return null;
    return (React.createElement("div", { className: "c-propsmsimilar" },
        React.createElement("div", { className: "c-propsmsimilar__items" }, props.sameBuilding.results.map(renderSimilarRow(props))),
        React.createElement("div", { className: "c-propsmsimilar__more" },
            React.createElement("a", { className: "o-btn o-btn--primary", href: props.sameBuildingMoreLink },
                React.createElement("span", { className: "fas fa-search" }),
                "\u00A0",
                props.t.viewMore))));
};
var renderPropSold = function (props) {
    var renderText = function (caption, link) {
        return link
            ? React.createElement("div", null,
                React.createElement("a", { href: link, dangerouslySetInnerHTML: { __html: caption } }))
            : React.createElement("div", { dangerouslySetInnerHTML: { __html: caption } });
    };
    return (React.createElement("div", { className: "c-propsold" },
        React.createElement("div", { className: "c-propsold__caption" }, renderText(props.unavailableInfo.title, "")),
        React.createElement("div", { className: "c-propsold__caption" }, renderText(props.unavailableInfo.caption, props.unavailableInfo.link))));
};
exports.renderPropSold = renderPropSold;
var isRenderingLayout = function (layout) {
    switch (layout) {
        case 'House':
        case 'Village House':
        case '獨立屋':
        case '村屋':
            return false;
        default:
            return true;
    }
};
var renderPropertyFloor = function (props) {
    if (!props.property.floor)
        return null;
    if (!isRenderingLayout(props.property.layout))
        return null;
    return (React.createElement("div", { className: "c-prophead__floor" },
        props.property.floor,
        props.t.floorRise));
};
exports.renderPropertyFloor = renderPropertyFloor;
var renderConfigGroup = function (props) { return props.property.address ? (React.createElement("div", { className: "c-prophead__configgroup" },
    React.createElement("div", { className: "c-prophead__config" },
        React.createElement("div", { className: "c-prophead__value" }, renderSize(props)),
        React.createElement("div", { className: "c-prophead__key" },
            props.t.sqft,
            " (",
            renderSizeSaGfa(props),
            ")")),
    React.createElement("div", { className: "c-prophead__config" },
        React.createElement("div", { className: "c-prophead__value" }, renderBeds(props)),
        React.createElement("div", { className: "c-prophead__key" }, props.t.beds)),
    React.createElement("div", { className: "c-prophead__config" },
        React.createElement("div", { className: "c-prophead__value" }, renderBaths(props)),
        React.createElement("div", { className: "c-prophead__key" }, props.t.baths)))) : null; };
exports.renderConfigGroup = renderConfigGroup;
var renderAddressGroup = function (props) { return props.property.address ? (React.createElement("div", { className: "c-prophead__addressgroup" },
    React.createElement("span", { className: "c-prophead__address" }, props.property.address),
    React.createElement("span", { className: "c-prophead__district" }, props.property.area))) : null; };
exports.renderAddressGroup = renderAddressGroup;
var renderMetaGroup = function (props) {
    return (React.createElement("div", { className: "c-prophead__metagroup" },
        renderListingType(props),
        renderPropertyFloor(props)));
};
var renderTitleGroup = function (props) {
    return (React.createElement("div", { className: "c-prophead__titlegroup" },
        renderDesktopBack(props),
        React.createElement("h1", { className: "c-prophead__title" }, props.property.building)));
};
exports.renderTitleGroup = renderTitleGroup;
var renderSize = function (props) {
    return props.property.sizeSaleable
        ? format_1.default.comma(props.property.sizeSaleable)
        : format_1.default.comma(props.property.sizeGross);
};
exports.renderSize = renderSize;
var renderSizeSaGfa = function (props) {
    return props.property.sizeSaleable ? props.t.sa : props.t.gfa;
};
exports.renderSizeSaGfa = renderSizeSaGfa;
var renderBeds = function (props) {
    var bedValue = props.property.amenities.find(function (it) { return it.key === 'bed'; }).value;
    if (bedValue === -1 || bedValue === '-1')
        return "-";
    return bedValue;
};
exports.renderBeds = renderBeds;
var renderBaths = function (props) {
    var bathValue = props.property.amenities.find(function (it) { return it.key === 'bath'; }).value;
    if (bathValue === -1 || bathValue === '-1')
        return "-";
    return bathValue;
};
exports.renderBaths = renderBaths;
var renderId = function (props) {
    return props.t.ref + ": " + props.property.referenceId;
};
var renderLastUpdated = function (props) {
    return props.t.updated + ": " + format_1.default.date(format_1.default.dateStringToDate(props.property.lastUpdated.toString()));
};
var renderPpsf = function (props) {
    if (props.property.isSubjectToOffer)
        return null;
    var isSaleSa = props.property.salePricePerSqftSaleable ? true : false;
    var salePpsf = props.property.salePricePerSqftSaleable
        ? props.property.salePricePerSqftSaleable
        : props.property.salePricePerSqftGross;
    if (salePpsf) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                "@ ",
                format_1.default.currencyPpsf(salePpsf),
                " / ",
                props.t.sqft,
                " (",
                isSaleSa ? props.t.sa : props.t.gfa,
                ")")));
    }
    if (salePpsf) {
        return (React.createElement(React.Fragment, null,
            "@ ",
            format_1.default.currencyPpsf(salePpsf),
            " / ",
            props.t.sqft,
            " (",
            isSaleSa ? props.t.sa : props.t.gfa,
            ")"));
    }
    return null;
};
exports.renderPpsf = renderPpsf;
var renderDesktopBack = function (props) {
    if (props.navBackUrl) {
        return (React.createElement("a", { className: "c-prophead__back", href: props.navBackUrl },
            React.createElement("span", { className: "fal fa-chevron-left" })));
    }
};
var renderListingType = function (props) {
    if (props.property.type === SfilterTypeGroup_1.SfilterType.RENT) {
        return React.createElement("div", { className: "c-prophead__type" }, props.t.forRent);
    }
    if (props.property.type === SfilterTypeGroup_1.SfilterType.BUY) {
        return React.createElement("div", { className: "c-prophead__type" }, props.t.forSale);
    }
    if (props.property.type === SfilterTypeGroup_1.SfilterType.BUYRENT) {
        return React.createElement("div", { className: "c-prophead__type" }, props.t.forSaleRent);
    }
};
exports.renderListingType = renderListingType;
exports.detail = function (props) {
    var stickyClass = classnames_1.default([
        'l-prop__info',
        'c-prophead',
        {
            'c-prophead--active': props.isSticking,
            'c-prophead--contact': props.isStickingContact,
        },
    ]);
    var propClass = classnames_1.default([
        'l-prop', 'l-prop--listingfirst',
        {
            'l-prop--notext': !props.property.description.trim()
        }
    ]);
    var listPropertyLink = "/" + props.langCode + "/property/list-property";
    var typestring = props.property.type === SfilterTypeGroup_1.SfilterType.BUY ? 'buy' : 'rent';
    var buildingName = format_1.default.normalize(props.property.building);
    var districtName = format_1.default.normalize(props.district.name);
    var linkType = props.building.isBlock === 1 ? 'block' : 'building';
    var buildingLink = "" + props.building.url;
    var districtLink = "" + props.district.url;
    var districtSearchLink = "/" + props.langCode + "/property-search/" + typestring + "/" + districtName;
    var agentUrl = "/" + props.langCode + "/real-estate-agents/" + format_1.default.normalize(props.agent.name) + "/" + props.agent.id;
    var onVrClick = function () { return props.onVrClick(); };
    var onNearbyClick = function () { return props.onNearbyClick(); };
    var onPropertyClick = function () { return props.onPropertyClick(); };
    var onMyPlacesClick = function () { return props.onMyPlacesClick(); };
    var onEnquireClick = function () { return props.onEnquireClick(); };
    var onWhatsAppClick = function () { return props.onWhatsAppClick(); };
    var onCallClick = function () { return props.onCallClick(); };
    var onCustomizeClick = function () { return props.onCustomizeClick(); };
    var onFeatureExpandClick = function () { return props.onFeatureExpandClick(); };
    var onFavClick = function () { return props.onFavClick(props.property); };
    var onMenuClick = function () { return props.onMenuClick(); };
    var onShareClick = function () { return props.onShareClick(); };
    var onBuildingUnfollowClick = function () { return props.onBuildingUnfollowClick(); };
    var onDistrictFollowClick = function () { return props.onDistrictFollowClick(); };
    var onDistrictUnfollowClick = function () { return props.onDistrictUnfollowClick(); };
    var renderPrice = function () {
        var renderSubjectToOffer = function () { return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "c-prophead__current--full" }, props.t.subjectToOffer),
            React.createElement("span", { className: "c-prophead__current--short" }, props.t.subjectToOffer))); };
        if (props.property.isLeaseSubjectToOffer && props.property.isSaleSubjectToOffer)
            return renderSubjectToOffer();
        var salePrice = props.property.salePrice;
        var leasePrice = props.property.leasePrice;
        var salePriceStr = format_1.default.currencyDetailSale(salePrice, props.langCode, props.symbol);
        var leasePriceStr = format_1.default.currencyDetailLease(leasePrice, props.langCode, props.symbol);
        var renderManagementFee = function () {
            if (props.property.includeManagementFee ===
                ResultPageState_1.ResultIncludeManagementFee.EXCLUDE) {
                return (React.createElement("span", { className: "c-prophead__current--caption" },
                    ' ',
                    props.t.excludeManagementFee));
            }
            if (props.property.includeManagementFee ===
                ResultPageState_1.ResultIncludeManagementFee.INCLUDE) {
                return (React.createElement("span", { className: "c-prophead__current--caption" },
                    ' ',
                    props.t.includeManagementFee));
            }
            return null;
        };
        var renderSale = function () {
            if (props.property.isSaleSubjectToOffer) {
                return (React.createElement(React.Fragment, null,
                    !props.property.isLeaseSubjectToOffer ? React.createElement("span", { style: { fontSize: '0.6em' } }, props.t.forSale) : '',
                    React.createElement("span", { className: "c-prophead__current--full" }, props.t.subjectToOffer),
                    React.createElement("span", { className: "c-prophead__current--short" }, props.t.subjectToOffer)));
            }
            if (!salePrice)
                return null;
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "c-prophead__current--full" }, salePriceStr),
                React.createElement("span", { className: "c-prophead__current--short" }, salePriceStr)));
        };
        var renderLease = function () {
            if (props.property.isLeaseSubjectToOffer) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "c-prophead__current--full" }, props.t.subjectToOffer),
                    React.createElement("span", { className: "c-prophead__current--short" }, props.t.subjectToOffer)));
            }
            if (!leasePrice)
                return null;
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "c-prophead__current--full" },
                    leasePriceStr,
                    renderManagementFee()),
                React.createElement("span", { className: "c-prophead__current--short" },
                    leasePriceStr,
                    renderManagementFee())));
        };
        return (React.createElement(React.Fragment, null,
            renderSale(),
            renderLease()));
    };
    var renderFeatureRow = function (label, value) { return (React.createElement("div", { className: "c-propfeature__row" },
        React.createElement("div", { className: "c-propfeature__col c-propfeature__col--label" }, label),
        React.createElement("div", { className: "c-propfeature__col c-propfeature__col--value" },
            React.createElement("div", { className: "c-propfeature__item c-propfeature__item--full" }, value)))); };
    var renderLayout = function () {
        var layout = props.property.layout;
        if (!layout)
            return '';
        return renderFeatureRow(props.t.layout, props.property.layout);
    };
    var renderFloor = function () {
        if (!props.property.floor)
            return '';
        if (!isRenderingLayout(props.property.layout))
            return '';
        return renderFeatureRow(props.t.floor, "" + props.property.floor + props.t.floorRise);
    };
    var renderBuildingAge = function () {
        if (props.property.buildingAge <= 0)
            return '';
        return renderFeatureRow(props.t.buildingAge, props.property.buildingAge + " " + props.t.years);
    };
    var renderBuildingRiseType = function () {
        if (!props.property.buildingRise)
            return '';
        return renderFeatureRow(props.t.buildingType, props.property.buildingRise);
    };
    var renderFacilites = function () {
        if (!props.building.features || !props.building.features.length)
            return '';
        var renderFacility = function (id, i) {
            var feature = PlaceFeatures_1.toFeature(id);
            if (!feature)
                return '';
            return (React.createElement("div", { className: "c-propfeature__item", key: i }, props.tFeature[feature.key]
                ? props.tFeature[feature.key]
                : feature.key));
        };
        return (React.createElement("div", { className: "c-propfeature__row c-propfeature__row--sm" },
            React.createElement("div", { className: "c-propfeature__col c-propfeature__col--label" }, props.t.facilities),
            React.createElement("div", { className: "c-propfeature__col c-propfeature__col--value" }, props.building.features.map(renderFacility))));
    };
    var renderFeatures = function () {
        if (!props.property.amenities)
            return '';
        var features = props.property.amenities.filter(function (it) { return it.key !== 'bed' && it.key !== 'bath'; });
        if (!features || !features.length)
            return '';
        var renderFeature = function (amenity, i) {
            if (amenity.value <= 0)
                return;
            var valueStr = amenity.value > 1
                ? amenity.value + " " + amenity.displayKey
                : "" + amenity.displayKey;
            return (React.createElement("div", { className: "c-propfeature__item", key: i }, valueStr));
        };
        return (React.createElement("div", { className: "c-propfeature__row c-propfeature__row--sm" },
            React.createElement("div", { className: "c-propfeature__col c-propfeature__col--label" }, props.t.features),
            React.createElement("div", { className: "c-propfeature__col c-propfeature__col--value" }, features.map(renderFeature))));
    };
    var renderCarparks = function () {
        if (props.property.parkingCoveredCount <= 0 &&
            props.property.parkingUncoveredCount <= 0) {
            return null;
        }
        var renderCarPark = function (n, coverType, included) {
            if (n <= 0)
                return null;
            var renderInclExcl = function (included) {
                if (included === null)
                    return null;
                return included ? props.t.includeCarpark : props.t.excludeCarpark;
            };
            return (React.createElement("div", { className: "c-propfeature__item" },
                React.createElement("span", { className: "u-mobile-hidden" },
                    n,
                    " ",
                    coverType,
                    " ",
                    renderInclExcl(included)),
                React.createElement("span", { className: "u-mobile-only" },
                    n,
                    " ",
                    coverType,
                    " ",
                    props.t.carparks,
                    " ",
                    renderInclExcl(included))));
        };
        return (React.createElement("div", { className: "c-propfeature__row c-propfeature__row--sm" },
            React.createElement("div", { className: "c-propfeature__col c-propfeature__col--label" }, props.t.carparks),
            React.createElement("div", { className: "c-propfeature__col c-propfeature__col--value" },
                renderCarPark(props.property.parkingCoveredCount, props.t.covered, props.property.parkingCoveredInclude),
                renderCarPark(props.property.parkingUncoveredCount, props.t.uncovered, props.property.parkingUncoveredInclude))));
    };
    var renderVrBlock = function (props) {
        if (!props.property.isVirtual)
            return '';
        var vrItem = props.gallery.items.find(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.VR; });
        var vrThumb = vrItem ? vrItem.thumb : '';
        return (React.createElement("div", { className: "l-prop__vr" },
            React.createElement("div", { className: "l-container l-container--r48 l-container--stackable l-pad--4 " },
                React.createElement("div", { className: "l-container__side" },
                    React.createElement("h2", { className: "o-h1" }, props.t.virtualTour),
                    React.createElement("div", { className: "u-caption" }, props.t.virtualTourCaption)),
                React.createElement("div", { className: "l-container__main" },
                    React.createElement("div", { onClick: onVrClick, className: "c-vrblock" },
                        React.createElement("div", { className: "c-vrblock__pic" },
                            React.createElement("div", { className: "c-vrblock__img" },
                                React.createElement("img", { src: vrThumb, alt: props.property.building }),
                                React.createElement("div", { className: "c-vrblock__overlay" },
                                    React.createElement("div", { className: "c-vrblock__action" },
                                        React.createElement("span", { className: "fas fa-play" }),
                                        React.createElement("br", null),
                                        React.createElement("span", { className: "c-vrblock__text" }, props.t.startvr))))),
                        React.createElement("div", { className: "c-vrblock__caption" },
                            props.t.wantToList,
                            "\u00A0",
                            React.createElement("a", { target: "_blank", href: listPropertyLink }, props.t.listYourProperty)))))));
    };
    var renderMetaCount = function (type, saleCount, rentCount) {
        var typeStr = type === SfilterTypeGroup_1.SfilterType.BUY || SfilterTypeGroup_1.SfilterType.BUYRENT ? props.t.forSale : props.t.forRent;
        var countStr = type === SfilterTypeGroup_1.SfilterType.BUY || SfilterTypeGroup_1.SfilterType.BUYRENT ? saleCount : rentCount;
        return countStr ? (React.createElement("div", { className: "c-explore__meta" },
            React.createElement("span", { className: "c-explore__metalabel" }, typeStr),
            "\u00A0",
            React.createElement("span", { className: "c-explore__metavalue" }, countStr))) : null;
    };
    var renderMetaAvg = function (type, saleAvg, rentAvg, lang) {
        var avgPrice = type === SfilterTypeGroup_1.SfilterType.BUY || SfilterTypeGroup_1.SfilterType.BUYRENT ? saleAvg : rentAvg;
        return avgPrice ? (React.createElement("div", { className: "c-explore__meta" },
            React.createElement("span", { className: "c-explore__metalabel" }, props.t.avg),
            "\u00A0",
            React.createElement("span", { className: "c-explore__metavalue" }, type === SfilterTypeGroup_1.SfilterType.BUY || SfilterTypeGroup_1.SfilterType.BUYRENT ? format_1.default.currencyPpsf(avgPrice, props.symbol) : format_1.default.currencyDetailLease(avgPrice, lang)),
            React.createElement("span", { className: "c-explore__metalabel" }, type === SfilterTypeGroup_1.SfilterType.BUY || SfilterTypeGroup_1.SfilterType.BUYRENT ? " / " + props.t.sqft : ''))) : null;
    };
    var renderVrTextLink = function () {
        if (!props.property.isVirtual)
            return null;
        return (React.createElement("div", { className: "c-proptext__vr" },
            React.createElement("a", { onClick: onVrClick, className: "o-textbtn" },
                React.createElement("span", { className: "far fa-play-circle" }),
                " ",
                props.t.startvr)));
    };
    var renderSmallMap = function (props) {
        var config = props.nearbyMap.small;
        var renderObject = function (object, i) {
            return MapObject_1.renderMapObject(object, i, function () { }, function () { }, function () { });
        };
        return config.objects && config.objects.length ? (React.createElement(myokay_map2_1.GoogleMap, __assign({}, config.mapState), config.objects.map(renderObject))) : null;
    };
    var renderDescription = function () {
        if (!props.property.description)
            return null;
        return (React.createElement("div", { className: "l-prop__text" },
            React.createElement("div", { className: "c-proptext" },
                React.createElement("div", { className: "c-proptext__quote" },
                    React.createElement("div", { className: "o-openquote" },
                        React.createElement("img", { src: "/res/img/quote.png", alt: "" }))),
                React.createElement("div", { className: "c-proptext__text" }, props.property.description),
                renderVrTextLink())));
    };
    var getItemClass = function (type) {
        return classnames_1.default([
            'c-propmap__type',
            {
                'c-propmap__type--active': type === props.popNearbyTab,
            },
        ]);
    };
    var featureClass = classnames_1.default([
        'c-propfeature',
        {
            'c-propfeature--more': props.isFeatureExpand,
        },
    ]);
    var renderViewMoreFeature = function (props) {
        return props.isFeatureOverflow ? (React.createElement("div", { className: "c-propfeature__more" },
            React.createElement("a", { onClick: onFeatureExpandClick }, props.t.viewMore))) : null;
    };
    var renderSaveButton = function (props) {
        return props.property.isSaved ? (React.createElement("button", { onClick: onFavClick, className: "o-btn c-prophead__btn--active c-prophead__btn" },
            React.createElement("span", { className: "fas fa-heart" }),
            "\u00A0",
            React.createElement("span", { className: "c-prophead__btntext" }, props.t.saved))) : (React.createElement("button", { onClick: onFavClick, className: "o-btn c-prophead__btn" },
            React.createElement("span", { className: "fal fa-heart" }),
            "\u00A0",
            React.createElement("span", { className: "c-prophead__btntext" }, props.t.save)));
    };
    var renderSaveSmButton = function (props) {
        return props.property.isSaved ? (React.createElement("a", { onClick: onFavClick, className: "c-propsmtop__action" },
            React.createElement("span", { className: "fas fa-heart" }))) : (React.createElement("a", { onClick: onFavClick, className: "c-propsmtop__action" },
            React.createElement("span", { className: "fal fa-heart" })));
    };
    var renderMortaggeSection = function (props) {
        return (React.createElement("div", { className: "l-prop__mortgage" },
            React.createElement("div", { className: "c-prop__subtitle" }, props.t.mortgage),
            React.createElement("div", { className: "l-pad u-mobile-hidden" },
                React.createElement("h2", { className: "o-h1" }, props.t.mortgage)),
            React.createElement(Mortgage_1.default, null),
            React.createElement("div", { onClick: onCustomizeClick, className: "c-mortgagesm c-mortgagesm--lr" },
                React.createElement("div", { className: "c-mortgagesm__container c-mortgagesm--more" },
                    React.createElement("div", { className: "c-mortgagesm__icon" },
                        React.createElement("span", { className: "fas fa-university" })),
                    React.createElement("div", { className: "c-mortgagesm__body c-mortgagesm__body--valign" },
                        React.createElement("div", { className: "c-mortgagesm__text" },
                            React.createElement("div", { className: "c-mortgagesm__text--left" },
                                props.t.hkd,
                                format_1.default.currencyLease(Math.ceil(props.mortgage.paymentPerMonth), props.langCode, props.symbol),
                                ' ',
                                props.t.perMonth)),
                        React.createElement("div", { className: "c-mortgagesm__caption" },
                            "@",
                            props.mortgage.interestRate,
                            props.t.percent,
                            ", \u00A0",
                            props.mortgage.durationInMonth / 12,
                            ' ',
                            props.t.yrs),
                        React.createElement("div", { className: "c-mortgagesm__more" }, props.t.custom))),
                React.createElement("div", { className: "c-mortgagesm__disclaimer" }, props.t.mortgageDisclaimer))));
    };
    var pageClass = classnames_1.default([
        'o-detail',
        'c-nav--safari',
        {
            'c-nav__menu-main--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.TOPMENU,
            'c-calloremail--active': props.callOrEmailActive,
        },
    ]);
    var renderStripes = function (props) {
        if (!props.property.banners)
            return null;
        var renderStripe = function (banner, i) {
            var sm = (props.langCode === 'en' && banner.label.length > 12) ||
                (props.langCode.indexOf('zh') > -1 && banner.label.length > 8);
            var classes = classnames_1.default(['c-result__stripe', {
                    'c-result__stripe--sm': sm,
                }]);
            return (React.createElement("div", { key: i, className: classes, style: { backgroundColor: banner.bannerColour, color: banner.labelColour } }, banner.label.toUpperCase()));
        };
        return props.property.banners.map(renderStripe);
    };
    var filterIsImage = function (it) {
        var urlPcs = it.src.toLowerCase().split('/');
        var lastPc = urlPcs[urlPcs.length - 1];
        var filePcs = lastPc.split('.');
        if (filePcs.length <= 1)
            return false;
        var extension = filePcs[filePcs.length - 1].toLowerCase();
        return ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'webp'].indexOf(extension) >= 0;
    };
    var renderBuildingPhoto = function (props) {
        var galleryItem = props.building.galleryItems.find(filterIsImage);
        var buildingImg = galleryItem ? galleryItem.src : "";
        return (React.createElement("div", { className: "c-explore__half" },
            React.createElement("div", { className: "c-explore__square" },
                React.createElement("div", { className: "c-explore__img" },
                    React.createElement("img", { loading: 'lazy', src: buildingImg ? buildingImg : '/res/img/nopic.jpg', alt: props.property.building })))));
    };
    var renderDistrictPhoto = function (props) {
        return (React.createElement("div", { className: "c-explore__half" },
            React.createElement("div", { className: "c-explore__square" },
                React.createElement("div", { className: "c-explore__img" },
                    React.createElement("img", { loading: 'lazy', src: props.district.image ? props.district.image : '/res/img/nopic.jpg', alt: props.property.area })))));
    };
    var renderContactButton = function (props) {
        var actionclass = classnames_1.default([
            'c-propagent__action'
        ]);
        return (React.createElement("div", { className: actionclass },
            React.createElement("button", { id: "enquireContactButton", onClick: onEnquireClick, className: "o-btn" },
                React.createElement("span", { className: "fal fa-envelope" }),
                React.createElement("span", { className: "c-propagent__action-text" }, props.t.message)),
            React.createElement("button", { id: "enquireContactButtonWa", onClick: onWhatsAppClick, className: "o-btn o-btn--contactwa" },
                React.createElement("span", { className: "o-btn-whatsapp-icon" }),
                React.createElement("span", { className: "c-propagent__action-text" }, "WhatsApp")),
            React.createElement("button", { id: "enquireContactButtonCall", onClick: onCallClick, className: "o-btn o-btn--contacttel" },
                React.createElement("span", { className: "fal fa-phone" }),
                React.createElement("span", { className: "c-propagent__action-text" }, props.t.telNo))));
    };
    var renderFollowbutton = function (props) {
        if (props.buildingFollowingId <= 0) {
            return (React.createElement("button", { onClick: props.onBuildingFollowClick, className: "c-explore__button o-btn o-btn--primary" }, props.t.follow));
        }
        return (React.createElement("button", { onClick: onBuildingUnfollowClick, className: "c-explore__button o-btn" }, props.t.unfollow));
    };
    var renderFollowbuttonDistrict = function (props) {
        if (props.districtFollowingId <= 0) {
            return (React.createElement("button", { onClick: onDistrictFollowClick, className: "c-explore__button o-btn o-btn--primary" }, props.t.follow));
        }
        return (React.createElement("button", { onClick: onDistrictUnfollowClick, className: "c-explore__button o-btn" }, props.t.unfollow));
    };
    var renderUnavailableInfo = function (props) {
        return props.unavailableInfo && props.unavailableInfo.title ? (React.createElement("div", { className: "l-prop__unavailable" }, renderPropSold(props))) : null;
    };
    var renderGallery = function (props) {
        return props.gallery.items.length ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "l-prop__gallery", style: { position: 'relative', overflow: 'hidden' } },
                React.createElement("div", { style: { position: 'relative', overflow: 'hidden' } },
                    React.createElement(DetailGalleryMain_1.default, __assign({}, props.gallery, { showVr: props.popActiveTab !== DetailPopTabType_1.DetailPopTabType.VR, defaultAltText: props.defaultAltText, banners: props.property.banners })),
                    renderStripes(props))))) : (React.createElement("div", { className: "l-prop__gallery", style: { position: 'relative', overflow: 'hidden' } },
            React.createElement("div", { className: "c-propslider__empty" },
                React.createElement("div", { className: "c-hero__nopic" }, props.t.noPhoto))));
    };
    var renderPriceGroup = function () {
        return (React.createElement("div", { className: "c-prophead__pricegroup" },
            React.createElement("div", { className: "c-prophead__current" }, renderPrice()),
            React.createElement("div", { className: "c-prophead__ppsf" }, renderPpsf(props)),
            React.createElement("div", { className: "c-prophead__id" }, renderId(props)),
            React.createElement("div", { className: "c-prophead__update" }, renderLastUpdated(props))));
    };
    var renderBackOrMenu = function (props) {
        if (props.navBackUrl) {
            return (React.createElement("a", { className: "c-propsmtop__backbtn", href: props.navBackUrl },
                React.createElement("span", { className: "fal fa-chevron-left" })));
        }
        return null;
    };
    var exploreBuildingClass = classnames_1.default([
        'c-explore',
        {
            'c-explore--nophoto': !props.building.galleryItems.length,
        },
    ]);
    var exploreDistrictClass = classnames_1.default([
        'c-explore',
        'c-explore--reverse',
        {
            'c-explore--nophoto': !props.district.image,
        },
    ]);
    var loadingClass = classnames_1.default([
        'l-arch__loading',
        {
            'l-arch__loading--active': props.layout.isLoading,
        },
    ]);
    var agentTitleClass = classnames_1.default(['c-propagent__title']);
    var renderAgentLicense = function (props) {
        return props.agent.license ? (React.createElement("div", { className: "c-propagent__license" }, props.agent.license)) : null;
    };
    var renderAgentName = function (props, agentLink) {
        return props.agent.license ? (React.createElement("a", __assign({}, agentLink, { className: "c-propagent__name" }), props.agent.name)) : (React.createElement("span", { className: "c-propagent__name" }, props.agent.name));
    };
    var renderAgentImage = function (props, agentLink) {
        return props.agent.license ? (React.createElement("a", __assign({}, agentLink, { className: "c-propagent__img" }), props.agent.image ? (React.createElement("img", { loading: 'lazy', src: props.agent.image, alt: props.agent.name })) : (React.createElement("img", { src: '/res/img/dummy.jpg' })))) : (React.createElement("span", { className: "c-propagent__img" }, props.agent.image ? (React.createElement("img", { loading: 'lazy', src: props.agent.image, alt: props.agent.name })) : (React.createElement("img", { src: '/res/img/dummy.jpg' }))));
    };
    var contactSectionClass = classnames_1.default([
        'l-propmeta__contact'
    ]);
    var agentLink = props.agent.image ? { href: agentUrl } : {};
    // Render
    return (React.createElement("div", { className: pageClass },
        React.createElement(Message_1.default, null),
        React.createElement("div", { className: loadingClass },
            React.createElement("div", null,
                React.createElement("span", { className: "fal fa-sync fa-spin" }))),
        React.createElement(Message_1.default, null),
        React.createElement("div", { className: "l-prophead" },
            React.createElement("div", { className: "l-prophead__nav" },
                React.createElement(MegaMenu_1.default, null)),
            React.createElement("div", { className: "l-prophead__breadcrumb  c-breadcrumb__container u-mobile-hidden" },
                React.createElement("div", { className: "l-breadcrumb__container" },
                    React.createElement(Breadcrumb_1.default, null)))),
        React.createElement("div", { className: propClass },
            React.createElement("div", { className: "l-prop__smtop" },
                React.createElement("div", { className: "c-propsmtop__stick" },
                    React.createElement("div", { className: "c-propsmtop__back" }, renderBackOrMenu(props)),
                    React.createElement("div", { className: "c-propsmtop__actions" },
                        renderSaveSmButton(props),
                        React.createElement("a", { onClick: onShareClick, className: "c-propsmtop__action" },
                            React.createElement("span", { className: "fal fa-share-alt" }))))),
            React.createElement("div", { id: "sticky1", className: stickyClass },
                React.createElement("div", { className: "l-prophead c-prophead__background" },
                    React.createElement("div", { className: "l-prophead__container c-prophead__container" },
                        React.createElement("div", { className: "l-prophead__title" },
                            renderMetaGroup(props),
                            renderTitleGroup(props),
                            renderAddressGroup(props)),
                        React.createElement("div", { className: "l-prophead__price" }, renderPriceGroup()),
                        React.createElement("div", { className: "l-prophead__config" }, renderConfigGroup(props)),
                        (!props.unavailableInfo || !props.unavailableInfo.title) && (React.createElement("div", { className: "l-prophead__action" },
                            React.createElement("div", { className: "c-prophead__actiongroup" },
                                renderSaveButton(props),
                                React.createElement("button", { onClick: onShareClick, className: "o-btn c-prophead__btn" },
                                    React.createElement("span", { className: "fal fa-share-alt" }),
                                    "\u00A0",
                                    React.createElement("span", { className: "c-prophead__btntext" }, props.t.share)),
                                React.createElement("button", { title: props.tResult.contact, id: "enquireContactButtonTop", onClick: onEnquireClick, className: "o-btn c-prophead__btn c-prophead__btn--contact" },
                                    React.createElement("span", { className: "fal fa-envelope" }),
                                    React.createElement("span", { className: "c-prophead__btntext" }, props.t.contact)),
                                React.createElement("button", { title: "WhatsApp " + props.tResult.contact, id: "enquireWhatsAppContactButtonTop", onClick: onWhatsAppClick, className: "o-btn c-prophead__btn c-prophead__btn--contact c-prophead__btn--wa" },
                                    React.createElement("span", { className: "o-btn-whatsapp-icon" }),
                                    React.createElement("span", { className: "c-prophead__btntext" }, "WhatsApp")))))))),
            renderUnavailableInfo(props),
            renderGallery(props),
            renderDescription(),
            React.createElement("div", { className: "l-prop__meta" },
                React.createElement("div", { className: "l-propmeta" },
                    (!props.unavailableInfo || !props.unavailableInfo.title) &&
                        (React.createElement("div", { className: contactSectionClass },
                            React.createElement("div", { className: "c-prop__subtitle" }, props.t.contactAgent),
                            React.createElement("div", { className: "c-propagent" },
                                renderContactButton(props),
                                React.createElement("div", { className: "c-propagent__body" },
                                    renderAgentImage(props, agentLink),
                                    React.createElement("div", { className: "c-propagent__info" },
                                        renderAgentName(props, agentLink),
                                        renderAgentLicense(props),
                                        React.createElement("div", { className: agentTitleClass }, props.agent.title),
                                        renderContactButton(props)))))),
                    React.createElement("div", { className: "l-propmeta__feature" },
                        React.createElement("div", { className: "c-prop__subtitle" }, props.t.featureAndFacilities),
                        React.createElement("div", { className: featureClass },
                            React.createElement("div", { id: "featureblock", className: "c-propfeature__rows" },
                                renderLayout(),
                                renderFloor(),
                                renderFeatures(),
                                renderCarparks(),
                                renderBuildingAge(),
                                renderBuildingRiseType(),
                                renderFacilites()),
                            !props.isFeatureExpand ? renderViewMoreFeature(props) : null)))),
            React.createElement("div", { className: "l-prop__map", id: "detail-smallmap" },
                React.createElement("div", { className: "l-pad u-mobile-hidden" },
                    React.createElement("h2", { className: "o-h1" }, props.t.neighbouthood)),
                React.createElement("div", { className: "c-propmap" },
                    React.createElement("div", { onClick: onNearbyClick, className: "c-propmap__box" },
                        React.createElement("div", { className: "c-propmap__frame", style: { pointerEvents: 'none', cursor: 'pointer' } }, renderSmallMap(props))),
                    React.createElement(NearbyCommuteEstimator_1.default, null),
                    React.createElement("div", { className: "c-propmap__types" },
                        React.createElement("div", { onClick: onMyPlacesClick, className: getItemClass(DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE) },
                            React.createElement("span", { className: "c-propmap__icon", style: { backgroundColor: '#085963' } }),
                            props.t.myPlaces),
                        React.createElement("div", { onClick: onPropertyClick, className: getItemClass(DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES) },
                            React.createElement("span", { className: "c-propmap__icon", style: { backgroundColor: '#6b3135' } }),
                            props.t.nearbyProperties),
                        React.createElement("div", { onClick: onNearbyClick, className: getItemClass(DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL) },
                            React.createElement("span", { className: "c-propmap__icon", style: { backgroundColor: '#4971c5' } }),
                            props.t.schools),
                        React.createElement("div", { onClick: onNearbyClick, className: getItemClass(null) },
                            React.createElement("span", { className: "c-propmap__icon", style: { backgroundColor: '#999' } }),
                            props.t.more)),
                    React.createElement("button", { onClick: onNearbyClick, className: "c-propmap__fullscreen" },
                        React.createElement("span", { className: "fal fa-expand" }),
                        React.createElement("span", { className: "c-propmap__fullscreen-text" }, props.t.interactiveMap)))),
            props.hasVr ? renderVrBlock(props) : null,
            props.property.type !== SfilterTypeGroup_1.SfilterType.RENT
                ? renderMortaggeSection(props)
                : null,
            React.createElement("div", { className: "l-prop__building" },
                React.createElement("div", { className: exploreBuildingClass },
                    React.createElement("div", { className: "c-explore__container" },
                        React.createElement("div", { className: "c-explore__half c-explore__half--info" },
                            React.createElement("div", { className: "c-explore__info" },
                                React.createElement("div", { className: "c-explore__name" },
                                    React.createElement("div", { className: "c-explore__caption" },
                                        React.createElement("span", { className: "fal fa-compass" }),
                                        ' ',
                                        props.t.findOutMoreAbout),
                                    React.createElement("a", { href: buildingLink, className: "c-explore__titlegroup" },
                                        React.createElement("h2", { className: "c-explore__title" }, props.property.building),
                                        React.createElement("div", { className: "c-explore__open" },
                                            React.createElement("span", { className: "fal fa-chevron-right" }))),
                                    React.createElement("div", { className: "c-explore__metas" },
                                        renderMetaCount(props.property.type, props.building.forSaleCount, props.building.forRentCount),
                                        renderMetaAvg(props.property.type, props.building.medianSalePpsf, props.building.medianLeasePrice, props.langCode)),
                                    React.createElement("div", { className: "c-explore__actions" }, renderFollowbutton(props))))),
                        renderBuildingPhoto(props)))),
            React.createElement("div", { className: "l-prop__listing" }, renderSimilarProperties(props)),
            React.createElement("div", { className: "l-prop__district" },
                React.createElement("div", { className: exploreDistrictClass },
                    React.createElement("div", { className: "c-explore__container" },
                        React.createElement("div", { className: "c-explore__half c-explore__half--info" },
                            React.createElement("div", { className: "c-explore__info" },
                                React.createElement("div", { className: "c-explore__name" },
                                    React.createElement("div", { className: "c-explore__caption" },
                                        React.createElement("span", { className: "fal fa-compass" }),
                                        ' ',
                                        props.t.findOutMoreAbout),
                                    React.createElement("a", { href: districtLink, className: "c-explore__titlegroup" },
                                        React.createElement("h2", { className: "c-explore__title" }, props.property.area),
                                        React.createElement("div", { className: "c-explore__open" },
                                            React.createElement("span", { className: "fal fa-chevron-right" }))),
                                    React.createElement("div", { className: "c-explore__actions" },
                                        React.createElement("a", { className: "o-btn o-btn--flat", href: districtSearchLink },
                                            props.t.viewPropreties,
                                            "\u00A0"),
                                        React.createElement("a", { className: "o-btn o-btn--flat", href: districtLink },
                                            props.t.districtGuide,
                                            "\u00A0")),
                                    React.createElement("div", { className: "c-explore__actions" }, renderFollowbuttonDistrict(props))))),
                        renderDistrictPhoto(props)))),
            React.createElement(DetailChart_1.default, { isMobile: props.isMobile, hidden: !props.showChart }),
            React.createElement(DetailTransactions_1.DetailTransaction, { hidden: !props.showTransaction })),
        React.createElement(DetailPopup_1.DetailPopup, __assign({}, props, { lat: props.property.lat, lng: props.property.lng, popActiveTab: props.popActiveTab, isMortgageExpand: props.isMortgageExpand, nearbyMap: props.nearbyMap, hasVr: props.gallery.items.find(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.VR; })
                ? true
                : false, hasFloorPlan: props.galleryFloorPlans.items && props.galleryFloorPlans.items.length > 0, popRender: props.popRender, videos: props.videos, gallery: props.gallery, galleryPhotos: props.galleryPhotos, galleryFloorPlans: props.galleryFloorPlans, videoPlayer: props.videoPlayer, popNearbyTab: props.popNearbyTab, isNearbyEstimatorShowing: props.isNearbyEstimatorShowing, mortgage: props.mortgage, t: props.t, showPanel: true, isStreeMapDisplay: false })),
        React.createElement(Megafoot_1.default, null),
        React.createElement(Enquire_1.default, null),
        React.createElement(ServerSideSchema_1.default, null),
        React.createElement(CallOrEmail_1.default, null),
        React.createElement(Bigpopup_1.default, null),
        React.createElement(ExistingLogin_1.default, null),
        React.createElement(Signup_1.default, null),
        React.createElement(Login_1.default, null),
        React.createElement(Share_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, exports.mapDispatchToProps)(exports.detail);
